import { RenderImages } from "../../../designComponents/Table/renderMethods";
import Typography from "../../../designComponents/Typography";
import ReviewButtons from "./review/ReviewButtons";
import { SectionTitle, StyledCard, ValueText } from "./styles";
import { PropertyFeaturesProps } from "./types";

const fieldKey = "Inventory";

const InventoryCards = ({
  propertyDetail,
  isAccepted,
  setOpenReviewModal,
  hasPreviousReview,
  hasRecentReview,
  onViewReviews,
}: PropertyFeaturesProps) => {
  return (
    <StyledCard style={{ margin: 0, gap: 10 }}>
      <SectionTitle>Inventory</SectionTitle>
      {isAccepted !== null && (
        <Typography
          style={{
            alignItems: "center",
            gap: "6px",
            color: isAccepted ? "green" : "red",
            fontWeight: 600,
            fontSize: "1rem",
            padding: "4px 8px",
            borderRadius: "4px",
          }}
        >
          {isAccepted ? "Accepted" : "Rejected"}
        </Typography>
      )}
      <div
        style={{
          display: "flex",
          gap: 10,
          width: "100%",
          flexDirection: "column",
        }}
      >
        {propertyDetail?.property?.inventory &&
        propertyDetail?.property?.inventory.length > 0 ? (
          propertyDetail?.property.inventory.map((item, index) => (
            <div
              style={{
                width: "100%",
                backgroundColor: "rgba(160,160,160,0.1)",
                padding: "10px",
                borderRadius: "10px",
              }}
              key={index}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "12px",
                }}
              >
                <img
                  width={24}
                  height={24}
                  style={{ borderRadius: 50 }}
                  src={item?.category?.icon.icon}
                  alt="categories"
                />
                <ValueText>{item.category.title}</ValueText>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 30,
                }}
              >
                <Typography size={"title"} fontWeight="semibold">
                  {item.title}
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  margin: "10px 0px",
                }}
              >
                <RenderImages images={item?.images} resize={false} />
              </div>
              <ValueText>{item.description}</ValueText>
            </div>
          ))
        ) : (
          <ValueText>No inventories yet</ValueText>
        )}
      </div>
      <ReviewButtons
        fieldKey={fieldKey}
        hasPreviousReview={hasPreviousReview}
        hasRecentReview={hasRecentReview}
        isAccepted={!!isAccepted}
        onViewReviews={onViewReviews}
        setOpenReviewModal={setOpenReviewModal}
        underReview={propertyDetail?.property.status === "UNDER_REVIEW"}
      />
    </StyledCard>
  );
};

export default InventoryCards;
